import * as React from 'react';
import { useMemo } from 'react';
import { Routes, Route } from 'react-router-dom';

import { contentSuffix, deliverySuffix, shareSuffix, styleSuffix } from 'report/ReportRoutes';
import Delivery from 'report/report-creation/Delivery';

import Overview from './overview';
import Style from './Style';
import Content from './content';
import Share from './Share';

const reportCreationRoutes = (editAllowed: boolean, isCreating: boolean = false) => [
  { path: '', component: <Overview editAllowed={editAllowed} /> },
  { path: contentSuffix, component: <Content editAllowed={editAllowed} /> },
  { path: deliverySuffix, component: <Delivery editAllowed={editAllowed} /> },
  { path: styleSuffix, component: <Style editAllowed={editAllowed} /> },
  ...(isCreating ? [{ path: shareSuffix, component: <Share /> }] : []),
];

type Props = {
  editAllowed: boolean;
  isCreating?: boolean;
};

const ReportCreationRouter = ({ editAllowed, isCreating = false }: Props) => {
  const routes = useMemo(
    () =>
      reportCreationRoutes(editAllowed, isCreating).map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      )),
    [editAllowed, isCreating],
  );

  return <Routes>{routes}</Routes>;
};

export default ReportCreationRouter;
